import { combineReducers } from '@ngrx/store';

import { defaultPlaceReducer as defaultPlace } from '@shared/base-search-bar/store/reducers/default-place.reducer';
import { defaultAirportReducer as defaultAirport } from '@shared/base-search-bar/store/reducers/default-airport.reducer';
import { departureTerminalReducer as departureTerminal } from '@shared/base-search-bar/store/reducers/departure-terminal.reducer';
import { arrivalTerminalReducer as arrivalTerminal } from '@shared/base-search-bar/store/reducers/arrival-terminal.reducer';
import { departurePlaceReducer as departurePlace } from '@shared/base-search-bar/store/reducers/departure-place.reducer';
import { arrivalPlaceReducer as arrivalPlace } from '@shared/base-search-bar/store/reducers/arrival-place.reducer';
import { flightTypeReducer as flightType } from '@shared/base-search-bar/store/reducers/flight-type.reducer';
import { hourTypeReducer as hourType } from '@shared/base-search-bar/store/reducers/hour-type.reducer';
import { departureDateReducer as departureDate } from '@shared/base-search-bar/store/reducers/departure-date.reducer';
import { arrivalDateReducer as arrivalDate } from '@shared/base-search-bar/store/reducers/arrival-date.reducer';
import {
  passengerArrangementReducer as passengerArrangement
} from '@shared/base-search-bar/store/reducers/passenger-arrangement.reducer';
import { flightClassReducer as flightClass } from '@shared/base-search-bar/store/reducers/flight-class.reducer';
import { departurePlaceReducer as departureAirport } from '@shared/base-search-bar/store/reducers/departure-place.reducer';
import {
  autocompletePlacesReducer as autocompletePlaces
} from '@shared/base-search-bar/store/reducers/autocomplete-places.reducer';
import { ui } from '@shared/base-search-bar/store/reducers/ui';
import { airlineReducer as airline } from '@shared/base-search-bar/store/reducers/airline.reducer';
import { guestsPerRoomReducer as guestsPerRoom } from '@shared/base-search-bar/store/reducers/guests-per-room.reducer';
import { baggageIncludedReducer as baggageIncluded } from '@shared/base-search-bar/store/reducers/baggage-included.reducer';
import { branchCodeReducer as branchCode } from '@shared/base-search-bar/store/reducers/branch-code.reducer';
import { destinationPlaceReducer as destinationPlace } from '@shared/base-search-bar/store/reducers/destination-place.reducer';
import { pickUpPlaceReducer as pickUpPlace } from '@shared/base-search-bar/store/reducers/pickup-place.reducer';
import { dropOffPlaceReducer as dropOffPlace } from '@shared/base-search-bar/store/reducers/dropoff-place.reducer';
import { salesChannelReducer as salesChannel } from '@shared/base-search-bar/store/reducers/sales-channel.reducer';
import { packageStepReducer as packageStep } from '@shared/base-search-bar/store/reducers/package-step.reducer';
import { pickUpTimeReducer as pickUpTime } from '@shared/base-search-bar/store/reducers/pickup-time.reducer';
import { dropOffTimeReducer as dropOffTime } from '@shared/base-search-bar/store/reducers/dropoff-time.reducer';
import {
  autocompleteDestinationPlacesReducer as autocompleteDestinationPlaces
} from '@shared/base-search-bar/store/reducers/autocomplete-destination-places.reducer';
import {
  hotelDestinationPlaceReducer as hotelDestinationPlace
} from '@shared/base-search-bar/store/reducers/hotel-destination-place.reducer';
import {
  packageOriginPlaceReducer as packageOriginPlace
} from '@shared/base-search-bar/store/reducers/package-origin-place.reducer';
import {
  packageDestinationPlaceReducer as packageDestinationPlace
} from '@shared/base-search-bar/store/reducers/package-destination-place.reducer';
import {
  autocompleteExtraReducer as autocompleteExtra
} from '@shared/base-search-bar/store/reducers/autocomplete-extra.reducer';
import { travelExtraInputReducer as inputTravelExtra } from '@shared/base-search-bar/store/reducers/travel-extra-input.reducer';

export const searchBarRootReducer = combineReducers({
  departurePlace,
  defaultAirport,
  departureTerminal,
  arrivalTerminal,
  arrivalPlace,
  destinationPlace,
  pickUpPlace,
  dropOffPlace,
  pickUpTime,
  dropOffTime,
  flightType,
  departureDate,
  departureAirport,
  arrivalDate,
  passengerArrangement,
  guestsPerRoom,
  flightClass,
  defaultPlace,
  autocompletePlaces,
  airline,
  baggageIncluded,
  branchCode,
  salesChannel,
  packageStep,
  autocompleteDestinationPlaces,
  hotelDestinationPlace,
  packageDestinationPlace,
  packageOriginPlace,
  hourType,
  autocompleteExtra,
  inputTravelExtra,
  ui,
});
